export default __webpack_public_path__ + "static/media/pourquoi-creer-un-compte.cf74a6e4.jpg";